module.exports = __webpack_public_path__ + "img/S-WEB-Goal-15.74efa862.png";